export enum keys {
  SHOWROOM_FLAT_VIEW = 'SHOWROOM_FLAT_VIEW'
}
